// src/api.js
import axios from 'axios';

// 1) Leggo una variabile d'ambiente, altrimenti uso '/api'
const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || '/api';

export const api = axios.create({
  baseURL: apiBaseUrl,
});

// Interceptor per aggiungere automaticamente il token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);
